<pc-footer>
  <div class="footer">
    <div class="quote-footer-content">
      @if (fData().shouldShowBackButton) {
        <pc-back-btn
          [ariaText]="fData().backButtonText"
          [color]="fData().color"
          [fontSize]="pxToRem(14).toString().concat('rem')"
          [fontWeight]="'500'"
          [icon]="fData().backBtnIcon"
          [text]="fData().backButtonText"
          (backClicked)="onBackButtonClicked()"
        >
        </pc-back-btn>
      }
      @if (showQuoteOverviewFooter()) {
        <pc-separator [verticalHeight]="SEPARATOR_HEIGHT"></pc-separator>
        <pc-quote-overview></pc-quote-overview>
      }
    </div>
    @if (fData().shouldShowNextButton) {
      <pc-gradient-btn
        [icon]="fData().continueBtnIcon"
        [isDisabled]="isDisabled()"
        [isLoading]="fData().isLoading()"
        [text]="fData().continueBtnText()"
        (btnClicked)="onNextButtonClicked()"
      >
      </pc-gradient-btn>
    }
  </div>
</pc-footer>
